import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const freshsales = defineConnector({
  identifier: "freshsales",
  name: "Freshsales",
  tagLine: "Freshworks CRM for sales teams",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://.*\\.(myfreshworks\\.com/crm/sales/api|freshsales\\.io/api)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `Token token=${app.secret.apiKey}`,
      },
    ]),
  steps: [
    {
      title: "Get your Freshsales API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Freshsales](https://www.freshworks.com/crm/sales/) account. Click your profile picture in the top right and select **Profile Settings**, then open the **API Settings** tab to copy your API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "yourcompany.myfreshworks.com",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Freshsales domain (e.g., yourcompany.myfreshworks.com or yourcompany.freshsales.io)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://${domain}/crm/sales/api/contacts/view/1?per_page=1`,
  },
  publicEnvVars: ({ domain }) => ({
    FRESHSALES_URL: domain ? `https://${domain}` : "",
  }),
});
